import React, { useEffect, useState } from "react";
import { PROMO_FEATURES_ENABLED } from "../config/promoConfig";

export const Header = (props) => {
  const [dynamicPromoEnabled, setDynamicPromoEnabled] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://yuccan.tech';

  // Fetch current promo state from API and listen for changes
  useEffect(() => {
    const fetchPromoState = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/static-config/promo`);
        const result = await response.json();
        if (result.success) {
          setDynamicPromoEnabled(result.data.enabled);
        }
      } catch (err) {
        // Use static fallback on failure
      }
    };

    fetchPromoState();
    const interval = setInterval(fetchPromoState, 5000);

    // Listen for promo state changes from promotional banner component
    const handlePromoStateChange = (event) => {
      setDynamicPromoEnabled(event.detail.enabled);
    };
    const handleStorageChange = () => {
      const storedPromoEnabled = localStorage.getItem('promoEnabled');
      if (storedPromoEnabled !== null) {
        setDynamicPromoEnabled(storedPromoEnabled === 'true');
      }
    };

    window.addEventListener('promoStateChange', handlePromoStateChange);
    window.addEventListener('storage', handleStorageChange);
    handleStorageChange();

    return () => {
      clearInterval(interval);
      window.removeEventListener('promoStateChange', handlePromoStateChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [API_BASE_URL]);

  const isPromoEnabled = dynamicPromoEnabled !== null ? dynamicPromoEnabled : PROMO_FEATURES_ENABLED;

  // Calculate the total height of fixed elements above the hero
  const menuBarHeight = 80; // Approximate menu bar height
  const promoHeight = isPromoEnabled ? 50 : 0;
  const totalFixedHeight = menuBarHeight + promoHeight;

  const headerStyle = {
    marginTop: `${totalFixedHeight}px`,
    position: 'relative'
  };

  const introStyle = {
    backgroundPosition: 'center center',
    minHeight: 'calc(100vh + 50px)', // Increased to show more of background
    paddingTop: '110px', // Reduced by additional 20px to move content up
    paddingBottom: '0' // Removed bottom padding to show more of background
  };

  return (
    <header id="header" style={headerStyle}>
      <div className="intro" style={introStyle}>
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-12 intro-text">
                <h1 style={{
                  fontSize: '54px', 
                  lineHeight: '1.2', 
                  color: '#E0292A !important',
                  backgroundColor: 'rgba(255, 255, 255, 0.75)',
                  padding: '8px 10px',
                  borderRadius: '12px',
                  display: 'inline-block',
                  fontFamily: "'Lexend Deca', sans-serif",
                  maxWidth: '1000px'
                }}>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p style={{
                  color: '#E0292A !important', 
                  whiteSpace: 'pre-line', 
                  fontSize: '26px', 
                  lineHeight: '1.6', 
                  maxWidth: '800px', 
                  margin: '20px auto 60px', 
                  fontWeight: 'bold',
                  backgroundColor: 'rgba(255, 255, 255, 0.75)',
                  padding: '15px 25px',
                  borderRadius: '12px',
                  fontFamily: "'Lexend Deca', sans-serif"
                }}>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="#services"
                  className="btn btn-custom btn-lg page-scroll"
                  style={{ marginTop: '-40px' }}
                  onClick={(e) => {
                    // Only apply mobile scrolling behavior on mobile devices
                    const isMobile = window.innerWidth <= 768;
                    if (isMobile) {
                      e.preventDefault();
                      
                      // Calculate offset for mobile (same as menu links)
                      const menuBar = document.getElementById('menu');
                      const menuHeight = menuBar ? menuBar.offsetHeight : 80;
                      const promotionalBannerHeight = isPromoEnabled ? 50 : 0;
                      const totalOffset = menuHeight + promotionalBannerHeight;
                      
                      const targetElement = document.querySelector('#services');
                      if (targetElement) {
                        const targetPosition = targetElement.offsetTop - totalOffset;
                        window.scrollTo({
                          top: targetPosition,
                          behavior: 'smooth'
                        });
                      }
                    }
                    // On desktop, default page-scroll behavior remains unchanged
                  }}
                >
                  Find Out More
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
